import React from "react";

const badges = {
  coinSystem: require("../imgs/badges/brs/BR - System Integrator.png"),
  coinScripting: require("../imgs/badges/brs/BR - Scripting.png"),
  coinHost: require("../imgs/badges/brs/BR - Host Analyst.png"),
  coinNetwork: require("../imgs/badges/brs/BR - Network Analyst.png"),
  coinPowerShell: require("../imgs/badges/brs/BR - PowerShell Fundamentals.png"),
  coinIntel: require("../imgs/badges/brs/BR - Intel Analyst.png"),
  coinLinux: require("../imgs/badges/brs/BR - Intel Analyst.png"),
  coinTraffic: require("../imgs/badges/brs/BR - Intel Analyst.png"),
  coinForensics: require("../imgs/badges/brs/BR - Forensics One.png"),

  coinHerd: require("../imgs/badges/missions/M1 - Goat Herd.png"),
  coinWolf: require("../imgs/badges/missions/M10 - Crimson Wolf.png"),
  coinHermit: require("../imgs/badges/missions/M12 - Bold Hermit.png"),
  coinDragon: require("../imgs/badges/missions/M13 - Black Dragon.png"),
  coinBear: require("../imgs/badges/missions/M2 - Bear Treat.png"),
  coinWhale: require("../imgs/badges/missions/M3 - Desert Whale.png"),
  coinCobra: require("../imgs/badges/missions/M4 - Arctic Cobra.png"),
  coinWBear: require("../imgs/badges/missions/M5 - Wounded Bear.png"),
  coinTiger: require("../imgs/badges/missions/M6 - Angry Tiger.png"),
  coinOcean: require("../imgs/badges/missions/M8 - Ocean View.png"),
  coinWBear: require("../imgs/badges/missions/M5 - Wounded Bear.png"),

  coinCTF1: require("../imgs/badges/brs/BR - CTF1.png"),
  coinCTF2: require("../imgs/badges/brs/BR - CTF2.png"),
  coinCTF3: require("../imgs/badges/brs/BR - CTF3.png"),
  coinCTF4: require("../imgs/badges/brs/BR - CTF4.png"),
  coinCTF5: require("../imgs/badges/brs/BR - CTF5.png"),
};

const StudentIcon=()=>{
return(
  
  
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="41px"
     height="41px" viewBox="0 0 41 41" >
 
  <g>
    <g id="XMLID_2_">
      <g>
        <path className="st0" d="M30.3,19.5c0,0.9-0.2,1.4-0.8,1.8c-1,0.7-3,0.4-4.1,0.1c-0.1,0-0.3-0.1-0.4-0.1l0,0c0,0-1.8-0.5-3.7-3.1
          c-0.6-0.8-0.6-1.1-0.5-1.2c0,0,0.1-0.1,0.3-0.1c0.1,0,0.2,0,0.2,0c0.4,0.1,0.9,0.4,0.9,0.8l0,0.1l0.1,0.1c0.3,0.4,0.7,0.5,1,0.4
          c0.5-0.2,0.5-1,0.5-1.4l-0.1-0.4c-0.2-1.7-0.2-3.1,1.3-3.8c0.2-0.1,0.8-0.3,1.3-0.2C26.9,13,30.3,15.8,30.3,19.5z"/>
        <path className="st0" d="M27.8,10.8c0,0.7-0.2,1.1-0.4,1.4c0,0-0.1-0.1-0.1-0.1c0,0,0,0-0.1-0.1c-0.1-0.1-0.1-0.1-0.2-0.2
          c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.2-0.2l-0.2-0.1c-0.9-0.3-2,0.2-2.1,0.2c-2.3,1-2.1,3.2-1.9,4.7c-0.3-0.4-0.8-0.6-1.2-0.7
          c-0.7-0.1-1.3,0-1.6,0.5c-0.4,0.6-0.2,1.4,0.6,2.4c0.2,0.3,0.4,0.6,0.7,0.8c0,0,0,0,0.1,0.1c0.2,0.2,0.4,0.5,0.6,0.6
          c0,0,0,0,0.1,0.1c-0.4,0.6-0.9,0.7-1,0.7c-0.8,0-1.4-0.3-1.9-0.8c-1.1-1.2-1.3-3.5-1.3-4.9c0-0.6,0-1,0-1l0,0
          c0.1-0.1,0.1-0.2,0.2-0.3c0,0,0-0.1,0.1-0.1c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,1.1-1.3,0.7-2.3c0-0.1,0-0.1-0.1-0.2
          c0.5-0.8,2.5-2.9,4.9-2.9C26.2,8.2,27.8,9.6,27.8,10.8z"/>
        <path className="st0" d="M27,22.7L26,26c-0.1,0.1-0.7,0.4-2,0.1c-1.1-0.2-1.7-0.5-1.9-0.6l1.8-3.6c0.4,0.2,0.7,0.3,0.8,0.3
          c0,0,0,0,0,0c0,0,0.1,0,0.1,0c0,0,0,0,0,0c0.1,0,0.3,0.1,0.5,0.2c0,0,0,0,0.1,0c0.1,0,0.2,0,0.3,0.1c0,0,0.1,0,0.1,0
          c0.1,0,0.3,0.1,0.4,0.1c0,0,0,0,0,0c0.1,0,0.3,0.1,0.5,0.1c0,0,0.1,0,0.1,0C26.8,22.7,26.9,22.7,27,22.7z"/>
        <path className="st0" d="M18,11.7c0.2,0.3-0.2,0.9-0.5,1.3c-0.3,0.5-0.6,1-1,1.8c-0.6,1.3-1.2,3.5-2.1,7.8c-0.7,3.1-2.6,5-4.5,6.1
          c-1.9,1.1-3.8,1.4-4.4,1.4c-0.2,0-0.5,0-0.7-0.1c-0.9-0.1-1.4-0.4-1.4-0.6c0-0.3,0.1-0.5,0.4-0.8c0.2-0.2,0.4-0.3,0.6-0.6
          l0.4-0.4c1.3-1.1,3.2-7.4,3.4-8.2c0.1-0.5,0.2-1,0.3-1.5c0-0.1,0.1-0.3,0.1-0.4c0.1-0.3,0.2-0.6,0.3-0.8c0.1-0.2,0.1-0.3,0.2-0.4
          c0.1-0.2,0.2-0.5,0.3-0.7c0.1-0.1,0.1-0.3,0.2-0.4c0.1-0.2,0.2-0.4,0.3-0.6c0.1-0.1,0.2-0.2,0.2-0.3c0.1-0.2,0.3-0.3,0.4-0.5
          c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.2,0.3-0.3,0.4-0.4c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.1,0.3-0.3,0.5-0.4c0.1,0,0.1-0.1,0.1-0.1
          c0.2-0.1,0.4-0.3,0.6-0.3c0,0,0.1,0,0.1-0.1c1.8-1,3.4-0.9,3.5-0.9C17.4,11.3,17.8,11.5,18,11.7C18,11.7,18,11.7,18,11.7z"/>
      </g>
      <g>
      </g>
    </g>
    <path className="st0" d="M20.5,0C9.2,0,0,9.2,0,20.5S9.2,41,20.5,41S41,31.8,41,20.5S31.8,0,20.5,0z M30.2,37.4c0-0.1,0-0.3,0-0.4
      c0-3.2-2.8-8.4-3.8-10.1c-0.4,0.3-1.2,0.5-2.7,0.2c-1.3-0.2-2-0.6-2.3-0.9c-1.4,1-6.8,5.9-10.8,11C4.9,33.9,1,27.7,1,20.5
      C1,9.7,9.7,1,20.5,1C31.3,1,40,9.7,40,20.5C40,27.7,36.1,34,30.2,37.4z"/>
  </g>
  </svg>
  

)
}




const TrainerIcon=()=>{
  return(
    

   
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg"   x="0px" y="0px" width="41px"
       height="41px" viewBox="0 0 41 41"  >
 
    <g>
      <path className="st0" d="M24.7,16.3c0-0.1,0-0.2,0.1-0.3l0-0.1h0.1c0.3-0.5,0.8-1,0.9-1.1c0.3-0.3,1-1,0.7-1.3
        c-0.3-0.1-0.7,0.4-0.8,0.5c-0.2,0.2-0.6,0.6-1,0.2c-0.3-0.2-0.2-0.6-0.1-0.9c0.4-1,0.3-1.4-0.1-1.6c-0.2-0.1-0.7-0.2-1.2-0.3
        c-0.9-0.2-2-0.5-3-0.9c-0.3,0.7-1.1,2.2-1.1,3.3c0,0.3,0,0.6-0.1,1c-0.1,1-0.2,2.3,0.4,2.9c0.3,0.3,0.7,0.4,1.3,0.4
        C23.5,17.9,24.6,16.6,24.7,16.3z"/>
      <path className="st0" d="M20.8,19v3.4c0,0,0,0.5,0.5,0.9c0.4,0.4,1,0.5,1.9,0.5c1.8-0.1,2.5-0.5,2.7-0.7L25,17.5
        C24.3,18.2,23,18.9,20.8,19z"/>
      <path className="st0" d="M23.5,10.4c0.5,0.1,1,0.2,1.3,0.4c0.9,0.3,1,1.1,1,1.7c0.2-0.1,0.4-0.1,0.6-0.1c0,0,0,0,0,0
        c0.3,0,0.6,0.1,0.8,0.4c0.3,0.3,0.6,0.9-0.1,1.9c-0.3,0.5-0.7,0.8-0.7,0.8c-0.1,0.1-0.2,0.2-0.3,0.3c1.1-0.2,2.1-0.7,2.2-0.9
        c-0.1,0-0.4-0.2-0.4-0.6c0-0.3,0.1-0.4,0.4-0.7c0.4-0.5,1.3-1.4,1.3-2.3c0-0.4-0.2-0.6-0.2-0.6c-0.2-0.2-0.7-0.2-0.8-0.1l-0.6,0.1
        l0-0.6c0-2.1-3.2-3.1-4.4-3.1c-0.8,0-1.4-0.5-2-0.9c-0.5-0.4-1-0.8-1.7-0.8c-0.3,0-0.5,0.1-0.6,0.2c-0.4,0.4-0.5,1.2-0.5,1.5
        C18.7,9.3,21.6,10,23.5,10.4z"/>
      <path className="st0" d="M20.5,0C9.2,0,0,9.2,0,20.5S9.2,41,20.5,41S41,31.8,41,20.5S31.8,0,20.5,0z M20.5,1C31.3,1,40,9.7,40,20.5
        c0,3.8-1.1,7.3-3,10.3c-0.1-0.4-0.2-0.7-0.3-1.1c-0.1-0.4-0.2-0.8-0.3-1.2c-0.9-3.4-3.8-4.3-4-4.3l-5.5-1.3l0.1,0.4l-0.1,0.1
        c-0.1,0.3-0.8,1.1-3.7,1.3c-0.1,0-0.3,0-0.4,0c-0.9,0-1.7-0.2-2.2-0.7c-0.7-0.7-0.8-1.6-0.8-1.6h-5.6c-0.5,0.1-1.5,0.3-1.9,0.4
        c-0.6,0.3-5.1,1.7-7.4,1c-0.3-0.1-0.7-0.2-1.2-0.3c-0.7-0.1-1.5-0.3-2.5-0.6C1.1,22.1,1,21.3,1,20.5C1,9.7,9.7,1,20.5,1z
         M31.8,36.4c-1.2,0.9-2.5,1.6-3.9,2.2c0.4-2.2,0.9-4.3,1.5-5.3l0.4-0.8l0.5,0.7C30.2,33.3,31.2,34.6,31.8,36.4z M3.9,30.7
        c0.7,0.1,1.5,0.2,2.3,0.3c1.9,0.1,5,0,6.1-0.3c0.6-3.7,1.7-6.1,1.7-6.2l0.9,0.4c0,0-2.2,4.9-2,11.3c0,0.8,0.1,1.6,0.1,2.3
        C9.2,36.9,6,34.1,3.9,30.7z"/>
    </g>
    </svg>
    
    


  )
  }
  








class ScenariosIntro extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: "br",
    };
  }

  handleClick(event) {
    this.setState({
      active: event.target.id,
    });
  }

  componentDidMount() {}

  render() {
    return (
      <div className={"help-content " + this.state.active}>
        <div className="scenarios-hero">
        <h1 >Scenarios</h1>
          <div className="top">
            <div className="content">
              <div> <div>
                <h3>Foundational Scenarios</h3>
                <h4>Battle Rooms</h4>
                <p>Skill based hands-on labs for individual learners</p>
                <h5>
<StudentIcon/>

                  Players</h5>
                <ul>
                  <li>Practice basic cyber security skills</li>
                  <li> Use authentic virtual machines with simple networks </li>
                  <li>
                    Assist learner progression with hints and in-game advisor
                    which can be disabled for grading
                  </li>
                  <li> Supported through hints and an in-game advisor</li>
                </ul>

                <h5><TrainerIcon/>Trainers</h5>
                <ul>
                  <li>
                    {" "}
                    Assess skills for grading by disabling hints and in-game
                    advisor
                  </li>
                </ul>
              </div> </div>
              <div> <div>
                <h3>Specialized Scenarios</h3>
                <h4>Missions</h4>

                <p>
                  Multi-faceted offensive or defensive labs for individual play
                  OR team-based collaboration
                </p>
                <h5><StudentIcon/>Players</h5>
                <ul>
                  <li>Tackle real world inspired threat scenarios</li>
                  <li>
                    Synthesize skills and apply critical thinking to solve
                    problems
                  </li>
                  <li>
                    {" "}
                    Use authentic virtual machines with a range of industry
                    specific networks
                  </li>
                </ul>

                <h5><TrainerIcon/>Trainers</h5>
                <ul>
                  <li>
                    {" "}
                    Assess capability for grading by disabling hints and in-game
                    advisor{" "}
                  </li>
                  <li>
                    {" "}
                    Coach learners through real-time engagement in the cyber
                    range
                  </li>
                </ul>
              </div></div>

              <div><div>
                <h3>Assessments</h3>
                <h4>Capture the Flag Battle Rooms</h4>

                <p>
                  Multi-faceted exercises for individuals designed to challenge
                  and test skills
                </p>
                <h5><StudentIcon/>Players</h5>
                <ul>
                  <li>
                    {" "}
                    Use virtual machines to accomplish tasks and find flags
                  </li>
                  <li> No hints or in-game advisor are available </li>
                </ul>

                <h5><TrainerIcon/>Trainers</h5>
                <ul>
                  <li>
                    {" "}
                    Assess competencies for grading using time and flag
                    discovery metrics
                  </li>
                </ul>
              </div>
            </div></div>
            <div className="globe"></div>
          </div>
          <div className="bottom">
            <div className="tabs-wrapper">
              <div
                className="tab"
                id="br"
                onClick={(event) => this.handleClick(event)}
              >
            Foundational
              </div>
              <div
                className="tab"
                id="m"
                onClick={(event) => this.handleClick(event)}
              >
              Specialized 
              </div>
              <div
                className="tab"
                id="ctf"
                onClick={(event) => this.handleClick(event)}
              >
               Assessments
              </div>
            </div>
          </div>
        </div>
       
  {/*      <div className="intro-wrapper">
          <div>
            <a
              className={
                "scenario-desc " + (this.state.active == "br" ? "active" : "")
              }
              id="br"
              onClick={(event) => this.handleClick(event)}
            >
              <span className="scenario-title">
                {" "}
                <img alt="badge" src={badges.coinSystem.default} />{" "}
                <div>
                  <h3>Foundational Scenarios</h3>
                  <h4>BattleRooms</h4>
                </div>
              </span>
              <p>Skill based hands-on labs for individual learners</p>
              <h5>Players</h5>
              <ul>
                <li>Practice basic cyber security skills</li>
                <li> Use authentic virtual machines with simple networks </li>
                <li>
                  Assist learner progression with hints and in-game advisor
                  which can be disabled for grading
                </li>
                <li> Supported through hints and an in-game advisor</li>
              </ul>

              <h5>Trainers</h5>
              <ul>
                <li>
                  {" "}
                  Assess skills for grading by disabling hints and in-game
                  advisor
                </li>
              </ul>
            </a>
            <a
              className={
                "scenario-desc " + (this.state.active == "m" ? "active" : "")
              }
              id="m"
              onClick={(event) => this.handleClick(event)}
            >
              <span className="scenario-title">
                {" "}
                <img alt="badge" src={badges.coinHerd.default} />{" "}
                <div>
                  <h3>Specialized Scenarios</h3>
                  <h4>Missions</h4>
                </div>
              </span>

              <p>
                Multi-faceted offensive or defensive labs for individual play OR
                team-based collaboration
              </p>
              <h5>Players</h5>
              <ul>
                <li>Tackle real world inspired threat scenarios</li>
                <li>
                  Synthesize skills and apply critical thinking to solve
                  problems
                </li>
                <li>
                  {" "}
                  Use authentic virtual machines with a range of industry
                  specific networks
                </li>
              </ul>

              <h5>Trainers</h5>
              <ul>
                <li>
                  {" "}
                  Assess capability for grading by disabling hints and in-game
                  advisor{" "}
                </li>
                <li>
                  {" "}
                  Coach learners through real-time engagement in the cyber range
                </li>
              </ul>
            </a>
            <a
              className={
                "scenario-desc " + (this.state.active == "ctf" ? "active" : "")
              }
              id="ctf"
              onClick={(event) => this.handleClick(event)}
            >
              <span className="scenario-title">
                {" "}
                <img alt="badge" src={badges.coinCTF1.default} />{" "}
                <div>
                  <h3>Assessments</h3>
                  <h4>Capture the Flag Battle Rooms</h4>
                </div>
              </span>

              <p>
                Multi-faceted exercises for individuals designed to challenge
                and test skills
              </p>
              <h5>Players</h5>
              <ul>
                <li>
                  {" "}
                  Use virtual machines to accomplish tasks and find flags
                </li>
                <li> No hints or in-game advisor are available </li>
              </ul>

              <h5>Trainers</h5>
              <ul>
                <li>
                  {" "}
                  Assess competencies for grading using time and flag discovery
                  metrics
                </li>
              </ul>
            </a>{" "}
          </div>{" "}
        </div>*/}
      </div>
    );
  }
}

export default ScenariosIntro;
